export default {
  // Đã nộp
  Submitted: 0,
  // Cấp trên đã nhận báo cáo
  Recieved: 1,
  // Cấp trên từ chối nhận báo cáo
  Refused: 2,  
};
